import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";
import strawberry from "../assets/strawberry.png";
import fruit from "../assets/fruit.png";
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const { user, logout, loginWithGoogle, loginWithEmail, signupWithEmail, signupWithGoogle } = useAuth();
  
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [isEmailAuth, setIsEmailAuth] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [showUsernamePopup, setShowUsernamePopup] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");

  const addresses = [
    "Cama Park , Mumbai",
    "Sky Heights , Andheri west",
    "Vrindawan colony , Andheri East ",
    "Radhakrishana Apartment, Andheri west",
    "Akme Paradise, Ville Parle"
  ];

  useEffect(() => {
    if (user) {
      const fetchUserData = async () => {
        const userRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(userRef);
        if (!docSnap.exists()) {
          setShowUsernamePopup(true);
        }
      };
      fetchUserData();
    }
  }, [user]);
  
  useEffect(() => {
    const fetchAddress = async () => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          setSelectedAddress(docSnap.data().address || "");
        } else {
          const storedAddress = localStorage.getItem("selectedAddress");
          setSelectedAddress(storedAddress || "");
        }
      }
    };
    fetchAddress();
  }, [user]);
  
  const handleEmailAuth = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        await loginWithEmail(email, password);
      } else {
        const userCredential = await signupWithEmail(email, password);
        setShowUsernamePopup(true); // Show username popup after signup
        const newUser = userCredential.user;
        const userRef = doc(db, "users", newUser.uid);
        await setDoc(userRef, {
          email: newUser.email,
          address: "",
        });
      }
      setShowAuthModal(false);
    } catch (error) {
      
    }
  };

  const handleGoogleSignup = async () => {
    try {
      const userCredential = await signupWithGoogle();
      const newUser = userCredential.user;
      const userRef = doc(db, "users", newUser.uid);
      await setDoc(userRef, {
        email: newUser.email, 
        address: "",
      }, { merge: true });
      setShowUsernamePopup(true); 
      setShowAuthModal(false);
    } catch (error) {
      alert(error.message);
    }
  };

  

  
  const handleSaveUsername = async () => {
    if (!username.trim()) {
      alert("Username cannot be empty!");
      return;
    }
    if (user) {
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, { username: username.trim() , email:user.email}, { merge: true });
      setShowUsernamePopup(false);
    }
  };
  
  const handleStartShopping = async () => {
    if (user) {
      const userRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(userRef);
  
      if (docSnap.exists() && docSnap.data().address) {
        navigate("/shop"); 
      } else {
        setShowAddressPopup(true); 
      }
    } else {
      setShowAddressPopup(true); 
    }
  };
  
  const handleAddressSelection = async () => {
    if (!selectedAddress) {
      alert("Please select an address before proceeding.");
      return;
    }
    if (user) {
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, { address: selectedAddress }, { merge: true });
    }
    localStorage.setItem("selectedAddress", selectedAddress);
    setShowAddressPopup(false);
    navigate("/shop");
  };
  
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      alert(error.message);
    }
  };
  

  return (
    <div className="home-container">
      {/* Navbar */}
      <nav className="navbar">
        <div className="logo">🍍 AlwaysOrganic</div>
        <ul className="nav-links">
          <li>About Us</li>
          <li>Our Locations</li>
          <li>Order in the App</li>
        </ul>

        <div className="auth-buttons">
          {user ? (
            <div className="user-dropdown">
              <img
                src={user.photoURL || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                alt="User"
                className="user-icon"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              />
              {dropdownOpen && (
                <div className="dropdown-menu">
                   {user.email === "saumya03pandey@gmail.com" ? (
                    <>
                      <button onClick={() => navigate("/admin")}>Go to Admin Panel</button>
                      <button onClick={() => navigate("/account")}>Account</button>
                      <button onClick={logout}>Logout</button>
                    </>
                  ) : (
                    <>
                  <button onClick={() => navigate("/account")}>Account</button>
                  <button onClick={logout}>Logout</button>
                  </>
                  )}
                </div>
              )}
            </div>
          ) : (
            <>
              <button className="login" onClick={() => { setShowAuthModal(true); setIsLogin(true); }}>Log In</button>
              <button className="signup" onClick={() => { setShowAuthModal(true); setIsLogin(false); }}>Sign Up</button>
            </>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <div className="hero">
        <div className="hero-text">
          <h1>Organic fruit <span className="highlight">products</span> brought right to your door.</h1>
          <p>We believe that fresh natural organic fruit products should be accessible to all.</p>
          <button className="shop-btn" onClick={handleStartShopping}>Start Shopping</button>
        </div>
        <div className="image-container">
          <img className="strawberry" src={strawberry} alt="Strawberry" />
          <img className="fruit" src={fruit} alt="Fruit" />
        </div>
      </div>
      {/* Address Popup */}
      {showAddressPopup && (
        <div className="address-overlay">
          <div className="address-popup">
            <button className="close-btn" onClick={() => setShowAddressPopup(false)}>×</button>
            <h2>Select Address</h2>
            <select value={selectedAddress} onChange={(e) => setSelectedAddress(e.target.value)}>
              <option value="">Select an address</option>
              {addresses.map((address, index) => (
                <option key={index} value={address}>{address}</option>
              ))}
            </select>
            <button className="shop-btn" onClick={handleAddressSelection}>Save Address</button>
          </div>
        </div>
      )}

      {/* Authentication Modal */}
      {showAuthModal && (
        <div className="auth-modal">
          <div className="auth-box">
            <button className="close-btn" onClick={() => setShowAuthModal(false)}>✖</button>
            <h2>{isLogin ? "Login" : "Sign Up"}</h2>

            {isEmailAuth ? (
              <form onSubmit={handleEmailAuth} className="email-auth-form">
                <input type="email" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <input type="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <button type="submit" className="email-auth-btn">{isLogin ? "Login" : "Sign Up"}</button>
                <p className="toggle-option" onClick={() => setIsEmailAuth(false)}>Or use Google</p>
              </form>
            ) : (
              <>
                <button className="google-auth" onClick={handleGoogleSignup}>
                  {isLogin ? "Sign in with Google" : "Sign up with Google"}
                </button>
                <p className="toggle-option" onClick={() => setIsEmailAuth(true)}>Or use Email</p>
              </>
            )}
          </div>
        </div>
      )}

      {/* Username Popup */}
      {showUsernamePopup && (
        <div className="username-overlay">
          <div className="username-popup">
            <button className="close-btn" onClick={() => setShowUsernamePopup(false)}>✖</button>
            <h2>Enter Your Username</h2>
            <input 
              type="text" 
              placeholder="Choose a username" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              required 
            />
            <button className="save-btn" onClick={handleSaveUsername}>Save</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
